// extracted by mini-css-extract-plugin
module.exports = {"addButton":"InitialLoading_addButton__i4aO4","loading":"InitialLoading_loading__EV-R0"};